import * as React from 'react'

export interface FlexProps extends React.HTMLAttributes<HTMLDivElement> {}

export const Flex = React.forwardRef<HTMLDivElement, FlexProps>(
    ({ className = '', ...rest }, ref) => (
        <div {...rest} ref={ref} className={`flex ${className}`} />
    ),
)

export const Row = React.forwardRef<HTMLDivElement, FlexProps>(
    ({ className = '', ...rest }, ref) => (
        <Flex {...rest} ref={ref} className={`flex-row ${className}`} />
    ),
)

export const Col = React.forwardRef<HTMLDivElement, FlexProps>(
    ({ className = '', ...rest }, ref) => (
        <Flex {...rest} ref={ref} className={`flex-col ${className}`} />
    ),
)
